import React, { useEffect, useState } from 'react'

export const useTruncation = (ref: React.RefObject<HTMLElement>) => {
  const [isTruncated, setIsTruncated] = useState(false)

  useEffect(() => {
    const element = ref.current
    if (!element) return

    const checkTruncation = () => {
      // Create a clone of the element to measure it without truncation
      const clone = element.cloneNode(true) as HTMLElement
      clone.style.display = 'inline'
      clone.style.width = 'auto'
      clone.style.visibility = 'hidden'
      clone.style.position = 'absolute'
      clone.style.whiteSpace = 'nowrap'
      document.body.appendChild(clone)

      const truncated = clone.offsetWidth > element.offsetWidth
      setIsTruncated(truncated)

      document.body.removeChild(clone)
    }

    checkTruncation()

    const resizeObserver = new ResizeObserver(checkTruncation)
    resizeObserver.observe(element)

    return () => {
      resizeObserver.disconnect()
    }
  }, [ref])

  return isTruncated
}
